import React from 'react';
import {
    SearchOutlined,
    Group,
    CloseOutlined,
    IconButton,
} from '@landr/maestro';
import { t } from '@lingui/macro';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import ActiveFilters from 'components/Filters/components/ActiveFilters/ActiveFilters';
import TextInput from '../TextInput/TextInput';
import * as Styled from './styled';

const FiltersAndInput = ({
    triggerRef,
    isSuggestionsOpen,
    isModal,
    hasSuggestions,
}: {
    triggerRef: React.RefObject<HTMLDivElement>;
    isSuggestionsOpen: boolean;
    isModal: boolean;
    hasSuggestions: boolean;
}) => {
    const {
        clearCtaLabel,
        handleApplyTextSearch,
        handleClearCta,
        hasFilterApplied,
        hasTextInputValue,
        isSearchBarDisabled,
    } = useSearchBarContext();

    const isCloseCtaVisible = hasTextInputValue || hasFilterApplied;

    const isBottomRadiusZero = isSuggestionsOpen && !isModal && hasSuggestions;

    return (
        <Styled.Wrapper
            isBottomRadiusZero={isBottomRadiusZero}
            ref={triggerRef}
            translate="no"
        >
            <Styled.Group alignItems="center" gutter="xs">
                <Styled.IconItem>
                    <IconButton
                        icon={SearchOutlined}
                        onClick={handleApplyTextSearch}
                        label={t`Apply Search`}
                        variant="subtle"
                        kind="link"
                        size="md"
                        isDisabled={isSearchBarDisabled}
                    />
                </Styled.IconItem>
                <Group.Item flexGrow={10}>
                    <Group flexWrap="wrap" gutter="xs" alignItems="center">
                        <ActiveFilters />
                        <TextInput />
                    </Group>
                </Group.Item>
                {isCloseCtaVisible && (
                    <Styled.IconItem>
                        <IconButton
                            icon={CloseOutlined}
                            variant="subtle"
                            kind="link"
                            size="md"
                            label={clearCtaLabel}
                            onClick={handleClearCta}
                        />
                    </Styled.IconItem>
                )}
            </Styled.Group>
        </Styled.Wrapper>
    );
};

export default FiltersAndInput;
